import { useNavigate } from "react-router-dom";
import { Monitor } from "lucide-react";

export const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative bg-gradient-to-b from-blue-100 via-blue-50 to-white min-h-[calc(100vh-80px)]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-28 py-12 lg:py-20">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-8 lg:gap-16">
          
          {/* Texto - Esquerda no desktop, abaixo no mobile */}
          <article className="flex-1 text-center lg:text-left max-w-2xl lg:max-w-none">
            <div className="relative inline-block p-4 mb-6 max-w-3xl">
              {/* Static corner borders */}
              <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-blue-900 rounded-tl-sm"></div>
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-blue-900 rounded-br-sm"></div>
            <h1 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-blue-900 leading-tight">
                <span className="font-extrabold brightness-110" style={{ color: '#02a8e4' }}>Soluções Inteligentes</span> para Recursos Hídricos
              </h1>
            </div>
            <p className="text-gray-700 text-lg sm:text-xl mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              Desenvolvemos soluções inovadoras para o monitoramento e gestão de recursos hídricos, 
              integrando tecnologia de ponta com expertise ambiental para garantir a sustentabilidade 
              e eficiência no setor elétrico brasileiro.
            </p>
            <button 
              onClick={() => navigate('/software-recursos')}
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 hover:scale-105 py-3 px-10 font-semibold text-white rounded-xl text-sm text-center uppercase transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              <Monitor className="w-4 h-4" />
              <strong>Softwares e Recursos</strong>
            </button>
          </article>
          
          {/* Ilustração - Direita no desktop, acima no mobile */}
          <div className="flex-1 flex justify-center lg:justify-end w-full">
            <img 
              src="/images/hero-illustration.webp?v=2" 
              alt="AHQ Consultoria - Soluções em Recursos Hídricos"
              className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg h-auto object-contain"
            />
          </div>
          
        </div>
      </div>
    </section>
  );
};
